import React from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';

const S3Plugin = React.lazy(() => importFromS3('crop-planning'));
const MFPlugin = React.lazy(() => import('cropPlanning/CropPlanning'));

export const CropPlanningPluginContainer: React.FC = () => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.cropPlanning.module-federation'];

  const CropPlanningPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return <CropPlanningPlugin />;
};
